var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.id,attrs:{"uk-modal":"bg-close: false"}},[_c('div',{staticClass:"uk-modal-dialog uk-modal-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }